export const resources = {
  junior: {
    macos: [
      { name: 'Software Testing Fundamentals', url: 'https://www.guru99.com/software-testing.html', type: 'fundamentals' },
      { name: 'Selenium WebDriver Guide', url: 'https://selenium-python.readthedocs.io/', type: 'automation' },
      { name: 'Postman API Testing', url: 'https://learning.postman.com/docs/', type: 'api-testing' },
      { name: 'TestRail Documentation', url: 'https://www.gurock.com/testrail/docs/', type: 'test-management' }
    ],
    windows: [
      { name: 'Microsoft Test Manager', url: 'https://docs.microsoft.com/en-us/azure/devops/test/', type: 'test-management' },
      { name: 'Visual Studio Test Tools', url: 'https://docs.microsoft.com/en-us/visualstudio/test/', type: 'testing-tools' },
      { name: 'Selenium with C#', url: 'https://docs.microsoft.com/en-us/dotnet/core/testing/', type: 'automation' },
      { name: 'Azure Test Plans', url: 'https://docs.microsoft.com/en-us/azure/devops/test/overview', type: 'test-planning' }
    ],
    linux: [
      { name: 'Linux Testing Tools', url: 'https://www.tecmint.com/linux-performance-monitoring-tools/', type: 'performance' },
      { name: 'Jenkins Test Automation', url: 'https://www.jenkins.io/doc/book/pipeline/jenkinsfile/', type: 'ci-cd' },
      { name: 'Docker for Testing', url: 'https://docs.docker.com/get-started/', type: 'containerization' },
      { name: 'Cypress Testing Framework', url: 'https://docs.cypress.io/', type: 'e2e-testing' }
    ]
  },
  mid: {
    macos: [
      { name: 'Advanced Test Automation', url: 'https://testautomationu.applitools.com/', type: 'automation' },
      { name: 'Performance Testing Guide', url: 'https://jmeter.apache.org/usermanual/', type: 'performance' },
      { name: 'Mobile Testing Strategies', url: 'https://appium.io/docs/en/about-appium/intro/', type: 'mobile' },
      { name: 'API Testing Best Practices', url: 'https://restfulapi.net/rest-api-testing/', type: 'api-testing' }
    ],
    windows: [
      { name: 'Load Testing with Azure', url: 'https://docs.microsoft.com/en-us/azure/load-testing/', type: 'performance' },
      { name: 'Coded UI Tests', url: 'https://docs.microsoft.com/en-us/visualstudio/test/use-ui-automation-to-test-your-code', type: 'ui-testing' },
      { name: 'Security Testing Guide', url: 'https://owasp.org/www-project-web-security-testing-guide/', type: 'security' },
      { name: 'Test Data Management', url: 'https://docs.microsoft.com/en-us/sql/tools/overview-sql-tools', type: 'data-management' }
    ],
    linux: [
      { name: 'Kubernetes Testing', url: 'https://kubernetes.io/docs/tasks/debug-application-cluster/debug-application/', type: 'infrastructure' },
      { name: 'Container Testing Strategies', url: 'https://testcontainers.org/', type: 'containerization' },
      { name: 'Continuous Testing', url: 'https://www.atlassian.com/continuous-delivery/software-testing', type: 'ci-cd' },
      { name: 'Monitoring and Observability', url: 'https://prometheus.io/docs/introduction/overview/', type: 'monitoring' }
    ]
  },
  senior: {
    macos: [
      { name: 'Test Strategy and Planning', url: 'https://www.ministryoftesting.com/', type: 'strategy' },
      { name: 'Quality Engineering', url: 'https://www.thoughtworks.com/insights/topic/quality-engineering', type: 'quality' },
      { name: 'Testing in Production', url: 'https://martinfowler.com/articles/testing-in-production.html', type: 'production-testing' },
      { name: 'Risk-Based Testing', url: 'https://www.guru99.com/risk-based-testing.html', type: 'risk-management' }
    ],
    windows: [
      { name: 'Enterprise Test Management', url: 'https://docs.microsoft.com/en-us/azure/devops/test/overview', type: 'management' },
      { name: 'Quality Metrics and KPIs', url: 'https://www.smartsheet.com/content/kpi-dashboard-examples', type: 'metrics' },
      { name: 'Compliance Testing', url: 'https://www.isaca.org/resources/isaca-journal/issues/2018/volume-1/testing-for-regulatory-compliance', type: 'compliance' },
      { name: 'Test Process Improvement', url: 'https://www.tmmi.org/', type: 'process-improvement' }
    ],
    linux: [
      { name: 'Chaos Engineering', url: 'https://principlesofchaos.org/', type: 'reliability' },
      { name: 'Site Reliability Testing', url: 'https://sre.google/books/', type: 'reliability' },
      { name: 'Advanced Monitoring', url: 'https://www.oreilly.com/library/view/effective-monitoring-and/9781491957349/', type: 'monitoring' },
      { name: 'Quality Culture', url: 'https://www.atlassian.com/agile/software-development/testing', type: 'culture' }
    ]
  }
};
